module.exports = __webpack_public_path__ + "img/Changhu_Wang@2x.93120b15.png";